import MicroModal from 'micromodal';

class Cart {
    constructor() {
        this.initializeModals();
        this.openModalByHash('cart-archive-store-modal');
    }

    initializeModals() {
        MicroModal.init({
            openClass: 'modal--open',
        });
    }

    openModalByHash(targetModalId) {
        const urlHash = window.location.hash.substring(1);
        if (urlHash === targetModalId) {
            MicroModal.show(targetModalId, {
                openClass: 'modal--open',
            });
        }
    }
}

export default Cart;
